export default __webpack_public_path__ + "static/michael-4aafa6409d0fb59895ae2f3c4f83f3fd.jpg";